import InputCheckbox from "components/page/user/contractFrk/edit/input/inputCheckbox";
import Input from "components/page/user/contractFrk/edit/input/inputNormal";
import { BlockBase, HeadlineHeader } from "components/page/user/contractFrk/edit/parts/blockBase";
import React from "react";
import Validation from "util/validate";

/** 所有者が負担すべき費用を特定の者にのみ減免する旨の規約等の定め */
export default class Block3 extends BlockBase {
    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            headlineId: "020903",
        };
        // 入力値のチェック用オブジェクトを生成
        this.validation = new Validation();
    }

    render() {
        const { hideBlockClass, params } = this.renderCommon();

        // 非表示判定の場合、null(react的な表示なし)を返す
        if (this.dohide(this.props.pageState.hidingHeadline)) { return null; }

        return (
            <div className={`dataList dataList__accordion ${hideBlockClass}`}>
                <div className="dataList-header">
                    <div className="dataList-header-title">所有者が負担すべき費用を特定の者にのみ減免する旨の規約等の定め</div>
                    <HeadlineHeader onClick={this.handleHide} hide={this.state.hide} />
                </div>
                <div className="dataList-body">
                    <table className="dataTable">
                        <tbody>
                            <tr>
                                <th className="dataTable-title dataTable-title__w120">規約の定め</th>
                                <td className="dataTable-body">
                                    <div className="dataTableUnit">
                                        <div className="dataTableUnit-input">
                                            <label className="checkBox">
                                                <InputCheckbox id="ID_JYU00935" name="JYU00935" checked={this.props.pageState.JYU00935} {...params} />
                                                <span className="checkBox-text">1.有</span>
                                            </label>
                                        </div>
                                        <div className="dataTableUnit-input">
                                            <label className="checkBox">
                                                <InputCheckbox id="ID_JYU01326" name="JYU01326" checked={this.props.pageState.JYU01326} {...params} />
                                                <span className="checkBox-text">2.無</span>
                                            </label>
                                        </div>
                                        <div className="dataTableUnit-text">別添管理規約</div>
                                        <Input id="ID_JYU00936" name="JYU00936" value={this.props.pageState.JYU00936} {...params} />
                                        <div className="dataTableUnit-text">条に記載されています。</div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th className="dataTable-title dataTable-title__w120" rowSpan="2">規約の定め<br />の概要</th>
                                <td className="dataTable-body">
                                    <Input id="ID_JYU00937" name="JYU00937" value={this.props.pageState.JYU00937} {...params} />
                                </td>
                            </tr>
                            <tr>
                                <td className="dataTable-body" colSpan="3">
                                    <Input id="ID_JYU01791" name="JYU01791" value={this.props.pageState.JYU01791} {...params} />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}